import './swiper';
import './lightbox2';
import './gsap';
import tabtoplevel from './tabtoplevel';
import tabFloorMapUmeda from './tab-floormap-omiya';
import tabFloormapHirakata from './tab-floormap-hirakata';
import tabFloorMapElectronic from './tab-electronic';
import tabHashLink from './tab-hashlink';
import accordion from './accordion';


accordion();

tabtoplevel();
tabFloorMapUmeda();
tabFloormapHirakata();
tabFloorMapElectronic();

tabHashLink();
// ↑ 1つのスクリプトで実現できないか？ class?


/* 右矢印を挿入する関数 */
function insertAdjacentArrow(target) {
  target.insertAdjacentHTML(
    'beforebegin',
    `<svg class="icon-before-arrow" width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.32012 6.38409L0.679932 5.61587L3.219 3.49998L0.679931 1.38409L1.32012 0.615873L4.78105 3.49998L1.32012 6.38409Z" fill="#111111"/>
    </svg>`
  );
}

/**
 * サーチリンクの前矢印追加 (svg)
 */

let nav_lists = document.querySelectorAll('#searchLink .list-name-only');

nav_lists.forEach((element) => {
  insertAdjacentArrow(element);
});

/**
 * 外部リンクのアイコン追加 (svg)
 */
nav_lists = document.querySelectorAll('a[target="_blank"]');

nav_lists.forEach(function (element) {
  element.insertAdjacentHTML(
    'beforeend',
    `<svg class="icon-external" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.14676 0.909091V6.56485e-07L10 0V3.81119H9.09091V1.55192L4.18508 6.45778C4.18508 6.44504 3.54225 5.81495 3.54225 5.81495L8.44809 0.909091H6.14676ZM0 1.70455H4.43184V2.61364H0.909132V9.09091H7.38638V5.56818C7.63741 5.56818 8.29546 5.56818 8.29546 5.56818V10H3.53041e-05L0 1.70455Z" fill="black"/>
    </svg>
    `
  );
});

/**
 * 縦ライン生成
 */

let vl = document.querySelector('#contentsLeft .vertical-line');
const heroTitle = document.getElementById('heroLeft');
const heroMv = document.getElementById('heroMv');
// 固定ページ
if (vl && heroTitle && heroMv) {
  vl.style.height = `calc(((${heroMv.clientHeight}px / 2) + 100%) - 48px )`;
  vl.style.top = `calc(((${heroMv.clientHeight}px / 2) * -1 ) + 52px )`;
}

const heroPostType = document.querySelector('#hero.post-type');
// アーカイブ・シングル
if (vl && heroTitle && heroPostType) {
  // vl.style.height = `calc(((${heroPostType.clientHeight}px / 2) + 100%) - 48px - 48px )`
  // vl.style.top = `calc(((${heroPostType.clientHeight}px / 2) * -1 ) + 48px + 48px )`
  // vl.style.height = `calc( ( (${heroPostType.clientHeight}px / 2) + 100% ) - ${heroTitle.clientHeight}px - 40px  )`
  vl.style.height = `100%`;
  vl.style.top = `0`;
}

/**
 * 最後の横ライン生成
 */
const endVerticalLine = document.querySelector('.end-horizontal-line');

if (endVerticalLine) {
  function getLeftPos() {
    const x = vl.getBoundingClientRect().left;
    const intx = Math.floor(x);
    endVerticalLine.style.left = `${intx}px`;
  }

  getLeftPos();

  window.addEventListener('resize', function () {
    getLeftPos();
  });
}

/**
 * 投稿系ページの画像に、lightboxの機能を付与するためのDOM操作
 */

// すべての画像要素を取得
const imgElements = document.querySelectorAll('body.single article .entry-content img');

// 各画像要素に対して処理を実行
imgElements.forEach((imgElement) => {
  // 1桁の乱数を生成
  const randomNum = Math.floor(Math.random() * 100000);

  // 新しい要素を作成
  const linkElement = document.createElement('a');
  linkElement.classList.add('zoom-image');

  // クリックする画像のsrcを取得する
  const imgUrl = imgElement.src;
  // 正規表現で拡張子手前の画像サイズ文字列(例:1000x1000など) を削除し、フルサイズ画像のurlとする
  const fullImgUrl = imgUrl.replace(/-\d+x\d+(?=\.\w+$)/, '');

  // 生成するaタグのhref属性に、フルサイズ画像のurlを指定
  linkElement.href = fullImgUrl;

  // data-lightboxに一意の乱数字を当てることで、ライトボックスのグループ化を防ぐ
  linkElement.setAttribute('data-lightbox', `randomNum-${randomNum}`);

  // img要素をa要素で囲む
  imgElement.parentNode.insertBefore(linkElement, imgElement);
  linkElement.appendChild(imgElement);
});

/**
 * カレンダーページ
 * カレンダーのマスの高さを指定
 * (タブ切り替えでカレンダーが崩れる症状の対処)
 */

// 基準となる大宮カレンダーのマスの高さを変数に格納
const calendarNum = document.querySelector('#calendarOmiya .wpsbc-date-inner');

if (calendarNum) {
  const height = Math.floor(calendarNum.clientHeight);

  // 3カレンダー全てのマスの高さを合わせる
  const calendarNums = document.querySelectorAll('.wpsbc-date-inner');
  calendarNums.forEach((item) => {
    item.style.lineHeight = `${height}px`;
  });
}

/**
 * カレンダー共通
 * 当日マスのcss borderを調整
 * (!importantでは調整不可のため)
 */
const calendarTodayCells = document.querySelectorAll('.wpsbc-date-today .wpsbc-legend-item-icon');
if (calendarTodayCells) {
  calendarTodayCells.forEach((item) => {
    const style = item.getAttribute('style');
    item.setAttribute('style', 'border: 3px solid #fff !important');
  });
}

/**
 * gutenbergのファイルダウンロードボタン
 */

const gutenbergDlBtns = document.querySelectorAll('a.wp-block-file__button');
gutenbergDlBtns.forEach((item) => {
  item.classList.add('btn', 'default', 'small');
  item.innerHTML = '<span>' + item.innerHTML + '</span>';
  const spanText = item.querySelector('span');
  insertAdjacentArrow(spanText);
});